import { RefObject, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { ProductType } from "../../shared/enums/ProductType";
import { productCardHelper } from "../../shared/helpers/productCardHelper";
import { productHelper } from "../../shared/helpers/productHelper";
import { useMarket } from "../../store/hooks/useMarket";
import ProductCard, { ProductCardMode } from "../ProductCard/ProductCard";
import "./GrappleModules.scss";
import ProductSeperator from "./ProductSeperator";
import { getImageUrl } from "../../shared/helpers/getImageUrl";

interface GrappleModulesProps {
  grappleModules: GrappleModule[];
  isNoneSelected: boolean;
  onChange(grappleModule: GrappleModule): void;
  onNoneChange(): void;
  refGrappleModules: RefObject<HTMLDivElement>;
  selectedGrappleModule: GrappleModule;
}

const GrappleModules = ({
  grappleModules,
  isNoneSelected,
  onChange,
  onNoneChange,
  refGrappleModules,
  selectedGrappleModule,
}: GrappleModulesProps) => {
  const market = useMarket();
  const { t } = useTranslation("tools");

  useEffect(() => {
    if (
      !selectedGrappleModule &&
      !isNoneSelected &&
      (!grappleModules || grappleModules.length === 0)
    ) {
      onNoneChange();
    }
  }, [grappleModules, onNoneChange, selectedGrappleModule, isNoneSelected]);

  if (!grappleModules || grappleModules.length === 0) {
    return <></>;
  }

  const isSelected = (grappleModuleId: number) => {
    if (!selectedGrappleModule) {
      return false;
    }

    return selectedGrappleModule.id === grappleModuleId;
  };

  return (
    <div ref={refGrappleModules}>
      <ProductSeperator />
      <h3>{t("grapplemodule.doyouwantgrapple")}</h3>
      <div className="grappleModules">
        {grappleModules.map((grappleModule) => {
          const productData = productHelper.getProductData({
            market,
            product: grappleModule,
            productType: ProductType.GrappleModules,
            t,
          });

          return (
            <ProductCard
              addTooltip={false}
              content={productHelper.getHtmlContent(productData)}
              height={productCardHelper.height}
              isSelected={isSelected(grappleModule.id)}
              key={grappleModule.id}
              localImage={getImageUrl(productData)}
              mode={ProductCardMode.SingleSelect}
              onChange={() => {
                onChange(grappleModule);
              }}
              preContent=""
              title={productData.name}
              tooltipText=""
            />
          );
        })}
        <ProductCard
          addTooltip={false}
          content=""
          height={productCardHelper.height}
          isSelected={isNoneSelected}
          key="none-selected-123"
          localImage=""
          onChange={onNoneChange}
          preContent=""
          title={`${t("grapplemodule.continuewithout")}`}
          tooltipText=""
        />
      </div>
    </div>
  );
};

export default GrappleModules;
